module.exports = __webpack_public_path__ + "img/chr_ts_90_3.4628dc58.png";